// API service for templates CRUD
import api from '../api';

export async function fetchTemplates() {
  const res = await api.get('/admin/api/templates');
  return res.data;
}

export async function createTemplate(template) {
  const res = await api.post('/admin/api/templates', template);
  return res.data;
}

export async function updateTemplate(id, template) {
  const res = await api.put(`/admin/api/templates/${id}`, template);
  return res.data;
}

export async function deleteTemplate(id) {
  await api.delete(`/admin/api/templates/${id}`);
}

export async function sendTestEmail(templateType, toEmail, subject) {
  await api.post('/admin/api/templates/send-test', { templateType, toEmail, subject });
}
